export default __webpack_public_path__ + "static/media/distanstolkning6.c5a31080.png";